import React from 'react'
import { useNavigate } from 'react-router'

import useDidMount from '@divvy-web/hooks.usedidmount'
import { FormattedMessage } from '@divvy-web/i18n'
import { BannerType } from '@divvy-web/skylab.banner'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import { useTrackCollaboratorEvent } from '@sputnik/hooks/useApplicationCollaborators'
import StatusBanner from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/ApplicationDetailsTabContent/ActionsNeededSection/StatusBanner'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'

interface UploadDocumentsBannerProps {
  salesforceCreditId: string
}

// this banner shows if requestedDocuments array is not empty
const UploadDocumentsBanner = ({ salesforceCreditId }: UploadDocumentsBannerProps) => {
  const navigate = useNavigate()
  const { trackCollaboratorEvent } = useTrackCollaboratorEvent({
    salesforceCreditId,
  })

  useDidMount(() => {
    trackCollaboratorEvent('se_signup__application_dashboard_action_needed_upload_documents__presented')
  })

  return (
    <div className='dd-privacy-allow'>
      <StatusBanner
        bannerType={BannerType.Warning}
        subtext={
          <FormattedMessage
            defaultMessage='Our team needs a few more things from you. <link>Upload documents</link>'
            id='sputnik.UploadDocumentsBanner__dezVS5'
            values={{
              link: (chunks) => (
                <TextLink
                  size={TextLinkSizes.SMALL}
                  onClick={() => {
                    trackCollaboratorEvent(
                      'se_signup__application_dashboard_action_needed_upload_documents__fired',
                      (role) => ({
                        person_type: role,
                      }),
                    )

                    navigate(
                      `${PATHNAME_CONSTS.DASHBOARD_PATH}/${salesforceCreditId}/${PATHNAME_CONSTS.DASHBOARD_PATH_DOCUMENTS_DRAWER}`,
                    )
                  }}
                >
                  {chunks}
                </TextLink>
              ),
            }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Upload documents'
            id='sputnik.UploadDocumentsBanner__1JRfgv'
          />
        }
      />
    </div>
  )
}

export default UploadDocumentsBanner
